<p-toast />
<div class="px-6 py-4">
  <div class="flex justify-content-between align-items-center mb-6">
    <div>
      <p class="text-xl font-semibold">
        {{ 'layout.configurations.documentTemplate.title' | translate }}
      </p>
      <p class="text-600 m-0 text-sm">
        {{ 'layout.configurations.documentTemplate.downloadExcelTemplate' | translate }}
      </p>
    </div>
  </div>

  <div class="grid">
    <ng-container *ngFor="let template of templatesList">
      
      <div class="col-12 sm:col-6 md:col-3 p-2" *ngIf="template.show">
        <div class="template-card surface-card border-round-lg shadow-2 p-4 cursor-pointer h-full"
          (click)="template.downloadAction()" 
          [class.downloading]="downloadStatus[template.id]">
          
          <div class="flex flex-column align-items-center gap-3">
            <div class="template-icon">
              <i class="pi text-4xl text-green-500"
                [class]="downloadStatus[template.id] ? 'pi-spin pi-spinner' : 'pi-file-excel'"></i>
            </div>
            
            <div class="text-center">
              <h3 class="text-lg font-semibold text-900 m-0 mb-1">
                {{ template.titleKey | translate }}
              </h3>
              <p class="text-600 text-xs m-0 mb-2 line-height-3">
                {{
                downloadStatus[template.id]
                ? ('layout.configurations.documentTemplate.downloadingTemplate' | translate)
                : (template.descKey | translate)
                }}
              </p>
            </div>
            
            <div class="download-hint">
              <p class="text-primary-500 text-xs font-medium m-0">
                <i class="pi pi-hand-pointer mr-1"></i>
                {{ 'layout.configurations.documentTemplate.clickToDownload' | translate }}
              </p>
            </div>
          </div>
          
        </div>
      </div>

    </ng-container>
  </div>
</div>